var _defs, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrivateGarage(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#f1f5ff;stroke-width:1.5px;}.a,.c{stroke:#353841;}.b{fill:#353841;}.c,.e{fill:none;}.c{stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}.d{stroke:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 74,
    height: 74,
    rx: 12
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    x: 0.75,
    y: 0.75,
    width: 72.5,
    height: 72.5,
    rx: 11.25
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(17 18.593)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.659 11.1)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M27.547,19.9H24.87a.694.694,0,0,1-.693-.693V17.529H22.635l.09,0c-.128-2.886-2.127-3.16-2.147-3.163s-3.71-.009-6.752-.009c-1.778,0-2.985,0-3.587.009-1.912.02-2.168,2.843-2.191,3.165H6.618V19.2a.694.694,0,0,1-.693.693H3.247a.694.694,0,0,1-.693-.693V9.671A1.435,1.435,0,0,1,3.578,8.291a.711.711,0,0,1-.006-.1H.762a.623.623,0,0,1-.549-.379,2.769,2.769,0,0,1,0-2.135.623.623,0,0,1,.549-.379H3.577a.623.623,0,0,1,.549.379,3.95,3.95,0,0,1,.194.778C5.575,4.032,6.913,1.443,6.926,1.418A1.128,1.128,0,0,1,7.782.691a42.292,42.292,0,0,1,15.23,0,1.124,1.124,0,0,1,.854.724c.014.03,1.426,2.76,2.608,5.035a3.775,3.775,0,0,1,.194-.778.623.623,0,0,1,.549-.379h2.814a.623.623,0,0,1,.549.379,2.777,2.777,0,0,1,0,2.135.623.623,0,0,1-.549.379H27.223c0,.036,0,.068-.006.1A1.445,1.445,0,0,1,28.24,9.671V19.2A.694.694,0,0,1,27.547,19.9Zm-3.466-9.834a12.858,12.858,0,0,0-2.167.235c-1.371.148-1.609,2.1-1.611,2.12h5.053c.008-.015.847-1.6,0-2.12A2.575,2.575,0,0,0,24.081,10.063Zm-17.139,0a2.572,2.572,0,0,0-1.274.235c-.854.525-.009,2.1,0,2.12h5.053c-.025-.2-.277-1.975-1.61-2.12A12.713,12.713,0,0,0,6.943,10.063Zm8.433-8.609a46.686,46.686,0,0,0-6.838.593L5.83,7.737H24.921L22.27,2.047h-.007A47.391,47.391,0,0,0,15.376,1.453Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1531.957,7869.41s.157-2.468,1.616-2.5,10.176,0,10.176,0,1.47.2,1.588,2.5C1543.385,7869.427,1531.957,7869.41,1531.957,7869.41Z",
    transform: "translate(-1523.259 -7851.925)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M6238.967,9246.848v-21.242l19.17-8.832,20.957,8.832v21.242",
    transform: "translate(-6238.967 -9216.773)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivateGarage);
export default __webpack_public_path__ + "static/media/private_garage.2fbbe48c07c6129e780e34b3c8e31a8e.svg";
export { ForwardRef as ReactComponent };